import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//actions:
import { openDialog, hideDialog, loading } from '../actions/index';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

//components:
import { postData } from '../dataLib';
import NeuriteGrid from '../components/neurite_grid';

import * as config from '../constants/configuration';

const styles = theme => ({
	root: {
		margin: 10
	},
	spinnerContainer: {
		width: '95%',
		height: 300,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	spinner: {
		width: '50px !important',
		height: '50px !important',
	},
	button: {
		margin: '15px 8px',
		padding: '10px',
		borderRadius: 0,
		textTransform: 'capitalize',
		color: 'white',
		border: 'none',
		boxShadow: 'none',
		width: 150,
	},
});

class ReportDataGrid extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			datasets: [],
			loading: true
		};
	};

	componentDidMount() {

		postData(config.REPORTS_API_URI() + '/PostJson',
			(response) => {

				this.processDataSets(response.data);
			},
			() => {
				this.props.openDialog('SimpleMessage', {
					message: 'ERROR obtaining report data'
				}, 'error-obtaining-report-data', false, 'sm');
			},
			this.props.reportValues,
			this.props.user,
			true
		);

	}


	processDataSets = (serverDataSets) => {

		var localDataSets = [];

		serverDataSets.forEach(ds => {

			var dataset = {};

			var columns = [];
			var rows = [];

			const page = ds.Page;

			ds.Columns.forEach((c, i) => {

				var type = '';
				switch (c.DataType) {
					case 'System.Int32':
						type = 'int';
						break;
					case 'System.String':
						type = 'string';
						break;
					case 'System.Double':
						type = 'float';
						break;
					case 'System.DateTime':
						type = 'date';
						break;
					case 'System.Boolean':
						type = 'bool';
						break;
					default:
						break;
				}
				columns.push({ key: c.Name, name: c.Name, editable: false, dragable: false, width: 100, type: type });

			});

			ds.Rows.forEach(r => {

				var row = {};
				ds.Columns.forEach((c, i) => {
					row[c.Name] = r.Values[i];
				});
				rows.push(row);

			});

			dataset = { columns: columns, rows: rows };

			if (localDataSets[page] === undefined) localDataSets[page] = [];
			localDataSets[page].push(dataset);

		});

		this.setState({ ...this.state, serverDatasets: serverDataSets, datasets: localDataSets, loading: false });

	}



	renderPages = () => {

		return this.state.datasets.map((p, i) => {

			const pagina = parseInt(i) + 1;

			if (p !== undefined) {return (
				<div>

					<Typography variant='h3' color='primary'>
						{'Página ' + pagina}
					</Typography>

					{this.renderDataGrids(p)}


				</div>
			)}else{
				return null;
			}
		})
	}


	renderDataGrids = (datasets) => {

		//const { classes } = this.props;

		return (
			datasets.map((ds, i) => {
				return (
					<div>
						{this.renderDataGrid(ds, i)}
						{/* <Button
							variant='contained'
							color='secondary'
							className={classes.button}
							onClick={() => this.downloadCsvData(ds)}
						>Descargar CSV</Button> */}
					</div>
				)
			})
		);

	}

	renderDataGrid = (dataSet, i) => {

		return (
			<NeuriteGrid
				id="r_d"
				key={'dataset_' + i}
				columns={dataSet.columns}
				rows={dataSet.rows}
				height={300}
				buttonEdit={false}
				buttonDelete={false}
				buttonNew={false}
				enableFilter={true}
				buttonCSV = {true}
				addTotal = {true}
			/>
		)

	}

	// downloadCsvData = (dataset) => {
	// 	var csvData = '';
	// 	dataset.columns.forEach(c => {
	// 		csvData += c.name + ';';
	// 	});
	// 	csvData = csvData.slice(0, -1);
	// 	csvData += '\n';

	// 	dataset.rows.forEach((r, i) => {

	// 		dataset.columns.forEach(c => {
	// 			csvData += r[c.name] + ';';
	// 		});

	// 		csvData = csvData.slice(0, -1);
	// 		csvData += '\n';

	// 	})

	// 	const link = document.createElement('a');
	// 	link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
	// 	link.setAttribute('download', 'dataset.csv');
	// 	document.body.appendChild(link);
	// 	link.click();
	// }

	render() {
		const { classes } = this.props;

		if (this.state.loading)
			return (
				<div className={classes.spinnerContainer}>
					<CircularProgress className={classes.spinner} color="primary" />
				</div>
			);

		return (
			<div>
				{this.renderPages()}
				<Button
					variant="contained"
					color="primary"
					className={classes.button}
					onClick={this.props.hideDialog}
				>Cerrar</Button>
			</div>
		);
	};
};

ReportDataGrid.propTypes = {
	reportValues: PropTypes.object.isRequired
};

function mapStateToProps(state) {
	return {
		user: state.oidc.user,
		userProfile: state.userProfile
	};
};

function mapDispathToProps(dispatch) {
	return bindActionCreators({
		hideDialog,
		openDialog,
		loading
	}, dispatch);
};


export default connect(
	mapStateToProps,
	mapDispathToProps
)(withStyles(styles, { withTheme: true })(ReportDataGrid));